import React from "react";
import classes from './closeButton.module.scss';
import classNames from "classnames";
import { BiX } from "react-icons/bi";

export const CloseButton = ({ onClose, className }) => {
    return (

        <button
            type="button"
            onClick={onClose}
            className={classNames(
                classes.closeButton,
                className,
                "w-[40px] h-[40px] rounded-full bg-primarysand text-[1.25rem] flex items-center justify-center transition-all"
            )}
        >
            <BiX />
        </button>
    )
}


export default CloseButton;